import { render, staticRenderFns } from "./HistoryTable.vue?vue&type=template&id=596f3f33"
import script from "./HistoryTable.vue?vue&type=script&lang=ts"
export * from "./HistoryTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports